import React, { useState } from "react";
import { Form, Card } from "react-bootstrap";
import { Button } from "@mantine/core";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

export default function Signup() {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const name = e.target.firstName.value + " " + e.target.lastName.value;
      const email = e.target.email.value;
      const password = e.target.password.value;
      const passwordConfirm = e.target.passwordConfirm.value;

      if (password !== passwordConfirm) {
        throw new Error("Passwords do not match");
      }
      const response = await axios.post(`${API_URL}/users/`, {
        name,
        email,
        password,
      });
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("userId", response.data.data.id);
      navigate("/");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div
      className="wrapper"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Card style={{ width: "18rem", height: "32rem" }}>
        <Card.Body>
          <h2 className="text-center mb-4">Sign Up</h2>
          <Form onSubmit={handleSignup}>
            <Form.Group id="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control type="firstName" name="firstName" required />
            </Form.Group>
            <Form.Group id="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control type="lastName" name="lastName" required />
            </Form.Group>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" required />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" name="password" required />
            </Form.Group>
            <Form.Group id="password-confirm">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control type="password" name="passwordConfirm" required />
            </Form.Group>
            <Button
              variant="gradient"
              gradient={{ from: "indigo", to: "cyan" }}
              className="w-100"
              type="submit"
              style={{ marginTop: "1rem" }}
            >
              Sign Up
            </Button>
            {error && <p style={{ color: "red" }}>{error}</p>}
          </Form>
        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2" style={{ color: "white" }}>
        Already have an account? <Link to="/login">Log In</Link>
      </div>
    </div>
  );
}
